var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-tool-section" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ctm-tool-section__body" },
      [
        !_vm.importedForms
          ? [
              _c(
                "div",
                {
                  staticClass: "ctm-upload-zone",
                  class: {
                    "ctm-upload-zone--drag": _vm.dragging,
                    "ctm-upload-zone--has-file": _vm.selectedFile
                  },
                  on: {
                    dragover: function($event) {
                      $event.preventDefault()
                      _vm.dragging = true
                    },
                    dragleave: function($event) {
                      $event.preventDefault()
                      _vm.dragging = false
                    },
                    drop: function($event) {
                      $event.preventDefault()
                      return _vm.onDrop($event)
                    },
                    click: function($event) {
                      return _vm.$refs.fileInput.click()
                    }
                  }
                },
                [
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "ctm-upload-zone__input",
                    attrs: { type: "file", accept: ".json" },
                    on: { change: _vm.onFileChange }
                  }),
                  _vm._v(" "),
                  !_vm.selectedFile
                    ? [
                        _c("i", {
                          staticClass: "el-icon-upload ctm-upload-zone__icon"
                        }),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c("p", { staticClass: "ctm-upload-zone__hint" }, [
                          _vm._v("Supports .json files exported from Contactum")
                        ])
                      ]
                    : [
                        _c("i", {
                          staticClass:
                            "el-icon-document ctm-upload-zone__icon ctm-upload-zone__icon--ready"
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "ctm-upload-zone__text ctm-upload-zone__text--ready"
                          },
                          [_vm._v(_vm._s(_vm.selectedFile.name))]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "ctm-upload-zone__hint" }, [
                          _vm._v(
                            _vm._s(_vm.fileSize) + " · Click to change file"
                          )
                        ])
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _vm.error
                ? _c("el-alert", {
                    staticStyle: { margin: "12px 0" },
                    attrs: {
                      title: _vm.error,
                      type: "error",
                      closable: false,
                      "show-icon": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "16px",
                    display: "flex",
                    gap: "10px",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-upload2",
                        loading: _vm.importing,
                        disabled: !_vm.selectedFile
                      },
                      on: { click: _vm.importForms }
                    },
                    [_vm._v("\n          Import Forms\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.selectedFile
                    ? _c("el-button", { on: { click: _vm.clearFile } }, [
                        _vm._v("\n          Clear\n        ")
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          : [
              _c("el-alert", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  title:
                    _vm.importedForms.length +
                    " form" +
                    (_vm.importedForms.length !== 1 ? "s" : "") +
                    " imported successfully.",
                  type: "success",
                  closable: false,
                  "show-icon": ""
                }
              }),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticClass: "ctm-import-results",
                  attrs: { data: _vm.importedForms }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "Form Name" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Action", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "a",
                              { attrs: { href: scope.row.edit_url } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      icon: "el-icon-edit"
                                    }
                                  },
                                  [_vm._v("Edit")]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.reset }
                },
                [_vm._v("\n        Import Another File\n      ")]
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-tool-section__head" }, [
      _c("h3", { staticClass: "ctm-tool-section__title" }, [
        _vm._v("Import Forms")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "ctm-tool-section__desc" }, [
        _vm._v(
          "\n      Upload a Contactum JSON export file to restore your forms. All field settings, notifications,\n      and form settings will be imported.\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "ctm-upload-zone__text" }, [
      _vm._v("\n            Drop your JSON file here, or "),
      _c("span", { staticClass: "ctm-upload-zone__link" }, [_vm._v("browse")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }